// Copyright (c) Docugami, Inc. All rights reserved.

import { NavigationType, useNavigationService } from "hooks/navigationService";
import { useServiceNotificationMarkAsRead } from "hooks/ServiceNotificationMarkAsRead";
import { InteractionStates, NotificationModel, WorkPathStatusContext, WorkPathStatusContextType } from "networking/NotificationsApi"
import { NotificationItemClickedSchema, TelemetryEvent } from "telemetry/TelemetryEvents";
import { Telemetry } from "telemetry/TelemetryManager";
import { NotificationItem, NotificationItemProps } from "./NotificationItem"

interface WorkPathStatusNotificationProps {
    model: NotificationModel;
    context: WorkPathStatusContext;
}

export const WorkPathStatusNotification = (props: WorkPathStatusNotificationProps): JSX.Element | null => {
    const navigationService = useNavigationService();
    const markAsRead = useServiceNotificationMarkAsRead();

    function primaryAction() {
        Telemetry.trackEvent<NotificationItemClickedSchema>({
            id: props.model.id,
            category: props.model.category,
            type: props.model.notificationType,
            eventName: TelemetryEvent.NotificationItemClicked
        })
        markAsRead([props.model.id], true);
        navigationService.navToWorkPathPage(NavigationType.PushNewPage, props.model.source.id!)
    }

    const message = getMessage(props.context);

    const itemProps: NotificationItemProps = {
        primaryAction: {
            action: () => primaryAction(),
            label: "View"
        },
        message: message,
        createdAt: props.model.createdAt,
        isRead: !!(props.model.interactions & InteractionStates.Read),
    }

    return !!message ? <NotificationItem {...itemProps} /> : null
}

function getMessage(context: WorkPathStatusContext) {
    if (context.type === WorkPathStatusContextType.Draft) {
        return `Pick up where you left off with ${context.workPathName}`;
    }
    else if (context.type === WorkPathStatusContextType.Unblocked) {
        return `We have successfully processed ${context.workPathName}, and are ready for next steps`;
    }

    return ''
}
